function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import styled from 'styled-components';
const StyledBlankSpace = styled.div`
  margin-top: ${props => props.rem}rem;
`;

class BlankSpace extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "render", () => {
      return /*#__PURE__*/React.createElement(StyledBlankSpace, {
        rem: !!this.props.rem ? this.props.rem : 1
      });
    });
  }

}

export default BlankSpace;